export enum CUSTOM_EXCEPTION_MESSAGES {
  LongPollingGatewayTimeoutException = 'Long Polling Gateway Timeout',
  ReceiptAlreadyLinkedToAnotherUserException = 'Receipt was already linked to another user',
  ExpiredSharingReceiptHashException = 'Expired sharing receipt hash',
  SharingReceiptHashNotFoundException = 'Sharing receipt hash is not found',
  ReceiptTokenNotFoundException = 'Receipt token not found',
  ReceiptTokenInvalidException = 'Receipt token is invalid',
  MasterReceiptNotFoundException = 'Receipt not found',
}
